import VidConf from './vidConf';
import JoinRoom from './joinRoom';
import React, {useRef, useEffect} from 'react';
import { selectPeers, 
    selectIsConnectedToRoom,
    useHMSActions,
    useHMSStore } from "@100mslive/react-sdk";

let meetings = require('../seeders/seedMeetings.json');
// let canvas = React.createRef();

const NDAER_URL_NGROK = "https://86a2-2600-1700-6450-4000-e90b-7ad6-121e-da45.ngrok.io/documents"
const NDAER_URL=  "http://localhost:3001/documents"
const Guest_vid ="https://townhall.app.100ms.live/meeting/ymm-jmt-lsr"
const copy ="a dynamic place to meet"
//  let el2
function LoginLogo(props) {
    function handleLogoClick(){
        window.location.href ="/hub"
    }
    return (
        <>
          <div id='login-logo-wrap'>
                <img src ="./images/TownHall_Logo_v2_3_2.png" alt="townhall logo" value="home" onClick={handleLogoClick} className="click-logo login-logo"/>
                <div id="scroll-container-login">
                    <div id="scroll-text">
                        <strong>{copy}</strong>
                    </div>
                </div>
            </div>
      </>

  );
}
export default LoginLogo; 